module.exports = __webpack_public_path__ + "img/logo-tr.623b7bfb.png";